import { Avatar } from '@ui'
import React, { FC } from 'react'

interface Props {
  logo?: string
  size?: number
  fallbackName?: string
  className?: string
}

const TokenAvatar: FC<Props> = ({ logo, size = 40, fallbackName, className }) => (
  <Avatar src={logo} size={size} fallback={fallbackName} alt={fallbackName} className={className} />
)

export default TokenAvatar
